import React, {Component} from 'react';
import Chart from "react-google-charts";

//cal rebre a través de props: valors percentatge i color

class GraficBatalla extends Component {	
    render() {    
        
    // Calculs per a valors absoluts de duel
    var resultat1 = Number(this.props.resultat1);
    var resultat2 = Number(this.props.resultat2);

    var sumatori = (resultat1 + resultat2);

    var resultat1_per = (resultat1/sumatori)*100;
    var resultat2_per = (resultat2/sumatori)*100;

     return (
        
            <div className="batallaComponent">
                {this.props.batalla &&
                <div>
                <div className="batallaEtiquetes">
                    <div className="batallaResultat1" style={{color:this.props.colorResultat1, width:(this.props.resultat1+"%")}}>{(resultat1)>5 && <span>Independentistes</span>}</div>
                    <div className="batallaResultatAltres" style={{color:"#4d4d4d", width:((100-resultat1-resultat2)+"%")}}>{(100-resultat1-resultat2)>5 && <span>Altres</span>}</div>
                    <div className="batallaResultat2" style={{color:this.props.colorResultat2, width:(this.props.resultat2+"%")}}>{(resultat2)>5 && <span>Unionistes</span>}</div>
                </div>
                    <div className="batallaEmboltori">
                        <div className="batallaResultat1" style={{backgroundColor:this.props.colorResultat1, width:(this.props.resultat1+"%")}}>{(resultat1)>5 && <span>{resultat1.toFixed(2).toString().replace(/\./g, ',')} % </span>}</div>
                        <div className="batallaResultatAltres" style={{backgroundColor:"#FFFFFF", width:((100-resultat1-resultat2)+"%")}}> {(100-resultat1-resultat2)>5 && <span>{(100-resultat1-resultat2).toFixed(2).toString().replace(/\./g, ',')} %</span>}</div>
                        <div className="batallaResultat2" style={{backgroundColor:this.props.colorResultat2, width:(this.props.resultat2+"%")}}>{(resultat2)>5 && <span> {resultat2.toFixed(2).toString().replace(/\./g, ',')} %</span>}</div>
                    </div>
                </div>
                }

                {this.props.duel &&
                    <div>

                        
                        <div className="batallaEtiquetes">
                            <div className="batallaResultat1" style={{color:this.props.colorResultat1, width:(resultat1_per+"%")}}>{(resultat1_per)>5 && <span>Vots JxCat</span>}</div>
                            <div className="batallaResultat2" style={{color:this.props.colorResultat2, width:(resultat2_per+"%")}}>{(resultat2_per)>5 && <span>Vots PDeCAT</span>}</div>
                        </div>
                        
                        <div className="batallaEmboltori">
                            <div className="batallaResultat1" style={{backgroundColor:this.props.colorResultat1, width:(resultat1_per+"%")}}>{(resultat1_per)>5 && <span>{(resultat1_per).toFixed(2).toString().replace(/\./g, ',')} % </span>}</div>
                            <div className="batallaResultat2" style={{backgroundColor:this.props.colorResultat2, width:(resultat2_per+"%")}}>{(resultat2_per)>5 && <span> {(resultat2_per).toFixed(2).toString().replace(/\./g, ',')} %</span>}</div>
                        </div>
                        <div className="nota">(JxCat + PDeCAT = {sumatori.toFixed(2).toString().replace(/\./g, ',')} % del total de vots vàlids)</div>
                    </div>
                }


            </div>
           
      );
    }
  }

  export default GraficBatalla;